import React, { useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

const ALLOWED_LICENSE_TYPES = ["basic", "plus", "max"];

const LicenseTab = ({ readOnly = false }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  const licenseType = values?.customer?.license?.type;

  // Default value: ensure basic is written into the model if missing/invalid.
  useEffect(() => {
    if (readOnly) return;
    if (!ALLOWED_LICENSE_TYPES.includes(licenseType)) {
      setFieldValue("customer.license.type", "basic");
    }
  }, [licenseType, setFieldValue, readOnly]);

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        {t("pages.dsokDetails.customerSettingsTabs.license.type.label")}
      </FormLabel>
      <FormHelperText sx={{ mb: 1 }}>
        {t("pages.dsokDetails.customerSettingsTabs.license.type.help")}
      </FormHelperText>

      <RadioGroup
        value={ALLOWED_LICENSE_TYPES.includes(licenseType) ? licenseType : "basic"}
        onChange={(e) => !readOnly && setFieldValue("customer.license.type", e.target.value)}
        name="license-type"
      >
        <FormControlLabel
          value="basic"
          control={<Radio disabled={readOnly} />}
          label={t("pages.dsokDetails.customerSettingsTabs.license.type.options.basic")}
        />
        <FormControlLabel
          value="plus"
          control={<Radio disabled={readOnly} />}
          label={t("pages.dsokDetails.customerSettingsTabs.license.type.options.plus")}
        />
        <FormControlLabel
          value="max"
          control={<Radio disabled={readOnly} />}
          label={t("pages.dsokDetails.customerSettingsTabs.license.type.options.max")}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default LicenseTab;

